export const patient = {
  patient: {
    id: 1,
    dateOfBirth: '2022-10-21',
    protocolId: '29a8e698-5623-11ed-8a06-dfa15ed776f9',
  },
};

export const reimbursementRequest = {
  requestList: [
    {
      amount: '10',
      submitDate: '2022-12-19T15:52:31.378Z',
      updatedAt: '2022-12-19T15:52:31.378Z',
      id: '2589b900-7fb5-11ed-aa27-0fcd8cfd83d7',
      paymentSubcategory: 'Visit 1a',
      patientId: '20298f14-413d-46c5-89db-b387a5678e0f',
      processorRewardLink: null,
      protocolId: '29a8e698-5623-11ed-8a06-dfa15ed776f9',
      protocolNumber: 'Pt Reimbursement Protocol',
      subjectId: 'GMpt-1 IxRS',
      siteId: 'fa8628ec-5f89-11ed-a1a5-e9394dc800b9',
      siteName: 'Sonoma Raceway',
      status: 1,
      statusUpdatedDate: '2022-12-19T15:52:31.378Z',
    },
    {
      amount: '10',
      submitDate: '2022-12-19T15:52:31.378Z',
      updatedAt: '2022-12-19T15:52:31.378Z',
      id: '2589b900-7fb5-11ed-aa27-0fcd8cfd83d2',
      paymentSubcategory: 'Visit 1a',
      patientId: '20298f14-413d-46c5-89db-b387a5678e0f',
      processorRewardLink: null,
      protocolId: '29a8e698-5623-11ed-8a06-dfa15ed776f9',
      protocolNumber: 'Pt Reimbursement Protocol',
      subjectId: 'GMpt-1 IxRS',
      siteId: 'fa8628ec-5f89-11ed-a1a5-e9394dc800b9',
      siteName: 'Sonoma Raceway',
      status: 2,
      statusUpdatedDate: '2022-12-19T15:52:31.378Z',
    },
    {
      amount: '10',
      submitDate: '2022-12-19T15:52:31.378Z',
      updatedAt: '2022-12-19T15:52:31.378Z',
      id: '2589b900-7fb5-11ed-aa27-0fcd8cfd83d3',
      paymentSubcategory: 'Visit 1a',
      patientId: '20298f14-413d-46c5-89db-b387a5678e0f',
      processorRewardLink: null,
      protocolId: '29a8e698-5623-11ed-8a06-dfa15ed776f9',
      protocolNumber: 'Pt Reimbursement Protocol',
      subjectId: 'GMpt-1 IxRS',
      siteId: 'fa8628ec-5f89-11ed-a1a5-e9394dc800b9',
      siteName: 'Sonoma Raceway',
      status: 3,
      statusUpdatedDate: '2022-12-19T15:52:31.378Z',
    },
    {
      amount: '10',
      submitDate: '2022-12-19T15:52:31.378Z',
      updatedAt: '2022-12-19T15:52:31.378Z',
      id: '2589b900-7fb5-11ed-aa27-0fcd8cfd83d4',
      paymentSubcategory: 'Visit 1a',
      patientId: '20298f14-413d-46c5-89db-b387a5678e0f',
      processorRewardLink: null,
      protocolId: '29a8e698-5623-11ed-8a06-dfa15ed776f9',
      protocolNumber: 'Pt Reimbursement Protocol',
      subjectId: 'GMpt-1 IxRS',
      siteId: 'fa8628ec-5f89-11ed-a1a5-e9394dc800b9',
      siteName: 'Sonoma Raceway',
      status: 4,
      statusUpdatedDate: '2022-12-19T15:52:31.378Z',
    },
    {
      amount: '10',
      submitDate: '2022-12-19T15:52:31.378Z',
      updatedAt: '2022-12-19T15:52:31.378Z',
      id: '2589b900-7fb5-11ed-aa27-0fcd8cfd83d5',
      paymentSubcategory: 'Visit 1a',
      patientId: '20298f14-413d-46c5-89db-b387a5678e0f',
      processorRewardLink: null,
      protocolId: '29a8e698-5623-11ed-8a06-dfa15ed776f9',
      protocolNumber: 'Pt Reimbursement Protocol',
      subjectId: 'GMpt-1 IxRS',
      siteId: 'fa8628ec-5f89-11ed-a1a5-e9394dc800b9',
      siteName: 'Sonoma Raceway',
      status: 5,
      statusUpdatedDate: '2022-12-19T15:52:31.378Z',
    },
    {
      amount: '10',
      submitDate: '2022-12-19T15:52:31.378Z',
      updatedAt: '2022-12-19T15:52:31.378Z',
      id: '2589b900-7fb5-11ed-aa27-0fcd8cfd83d5',
      paymentSubcategory: 'Visit 1a',
      patientId: '20298f14-413d-46c5-89db-b387a5678e0f',
      processorRewardLink: null,
      protocolId: '29a8e698-5623-11ed-8a06-dfa15ed776f9',
      protocolNumber: 'Pt Reimbursement Protocol',
      subjectId: 'GMpt-1 IxRS',
      siteId: 'fa8628ec-5f89-11ed-a1a5-e9394dc800b9',
      siteName: 'Sonoma Raceway',
      status: 6,
      statusUpdatedDate: '2022-12-19T15:52:31.378Z',
    },
  ],
};
